module.exports = __webpack_public_path__ + "media/Audio18_d.20b48298.wav";